import React from "react";
import avatar from "../../assets/avatar.jpeg";
import styles from "./userAccountDash.module.scss";
import { useGetUser } from "../../swr/user";
import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export interface UserAccountDashboardProps {
  email: string | undefined;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  userName: string;
}

const UserAccountDashboard: React.FC<UserAccountDashboardProps> = () => {
  const { signOut } = useAuth();
  const { user } = useGetUser();

  const logout = () => {
    signOut();
  };

  return (
    <div className="tab-pane fade active show" id="liton_tab_1_1">
      <div className="ltn__myaccount-tab-content-inner">
        <div className={styles.profile}>
          {user && user.imageURL ? (
            <img
              className={styles.demo_logo_last}
              src={user.imageURL}
              alt="Avatar"
            />
          ) : (
            <img className={styles.demo_logo_last} src={avatar} alt="Avatar" />
          )}
          <h3>{user?.userName}</h3>
        </div>
        <p>
          Hello <strong>{user?.userName}</strong> (not{" "}
          <strong>{user?.userName}</strong>?{" "}
          <small>
            <Link to="/logout" onClick={() => logout()}>
              Log out
            </Link>
          </small>{" "}
          )
        </p>
        <p>
          From your account dashboard you can view your <span>information</span>
        </p>
        <p>Username: {user?.userName}</p>
        <p>First Name: {user?.firstName}</p>
        <p>Last Name: {user?.lastName}</p>
        <p>Phone Number: {user?.phoneNumber}</p>
        <p>Email: {user?.email}</p>
        <p>Referral Code: {user?.referralCode}</p>
        <p>
          <Link to="/deletehomebuddyaccount">Delete Account</Link>
        </p>
      </div>
    </div>
  );
};

export default UserAccountDashboard;
